<div class="details-board">
  @for (group of orderShipment().lineGroups; track group.status) {
    <div class="status-column flex-layout column">
      <div class="flex-layout board-status-header">
        <span class="status-list-name">
          {{orderUtilityService.mapOrderDetailsStatus(group.status, orderShipment().orderType)}}
        </span>
      </div>
      
      <div id="{{group.status}}" class="status-list">
        @for (orderLine of group.orderLines; track orderLine) {
          <insight-order
            [orderLine]="orderLine"
            [orderScreen]="orderScreen.Details"
            [orderShipment]="orderShipment()">
          </insight-order>
        }
      </div>
    </div>
  }
</div>
